<div class="table-fms">
  <table>
    <thead>
      <tr>
        <th></th>
        <th># of companies</th>
        <th class="fix-w-7p5">Investment</th>
        <th class="fix-w-7p5">Proceeds</th>
        <th class="fix-w-7p5">Gain/(loss)</th>
        <th class="fix-w-7p5">MOIC</th>
      </tr>
    </thead>
    <tbody>
      <tr [class.total] = "metric === total" *ngFor="let metric of [atGain, atCost, atLoss, writeOff, total]">
        <td>{{metric.name}}</td>
        <td>{{metric.companiesNumber}}</td>
        <td>{{metric.investment | switcherDashBraces: 1 : 0 }}</td>
        <td>{{metric.proceeds | switcherDashBraces: 1 : 0 }}</td>
        <td>{{metric.gain | switcherDashBraces: 1 : 0 }}</td>
        <td>x{{metric.moic | number : '1.2-2'}}</td>
      </tr>
    </tbody>
  </table>
</div>
